import {useMemo} from 'react';
import {AssetWorkflow} from '@taopix/taopix-asset-manager';
import {useUploader} from '../../Components/Context/Upload/UploadContext';
import {useTaopix} from '../../Components/Context/TaopixContext';

const useAIStatusChecker = () => {
  const taopix = useTaopix();
  const uploader = useUploader();

  const monitor = useMemo(() => {
    if (0 === Object.keys(uploader).length || !taopix.state.loaded) return;

    return uploader.getMonitor(
      {
        code: '%TAOPIXONLINE%',
      },
      AssetWorkflow.AI
    );
  }, [uploader]);

  return monitor;
};

export default useAIStatusChecker;
